// packages/shared/src/services/timeTracking/timerMath.ts
export type TimerStatus = 'idle' | 'running' | 'paused';

export interface PauseSegment {
  pausedAt: string;          // ISO
  resumedAt: string | null;  // ISO, null = still paused
}

export interface TimerCoreState {
  status: TimerStatus;
  startedAt: string | null;  // ISO
  pauses: PauseSegment[];
}

/** Elapsed milliseconds, derived (never a stored counter). Clamped to >= 0. */
export function deriveElapsedMs(state: TimerCoreState, nowMs: number): number {
  if (state.status === 'idle' || !state.startedAt) return 0;
  const startMs = Date.parse(state.startedAt);
  let pausedMs = 0;
  for (const seg of state.pauses) {
    const from = Date.parse(seg.pausedAt);
    const to = seg.resumedAt ? Date.parse(seg.resumedAt) : nowMs;
    pausedMs += Math.max(0, to - from);
  }
  return Math.max(0, nowMs - startMs - pausedMs);
}
